let moment = require('moment');
moment = require('moment-timezone');

export default moment;